import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { IDetail, ISearchFields, Service } from './service'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { globalPrompt } from '@/components/message'
import { ModoulTypeList } from '@/types/TcoDs'
import { message } from 'antd'
import { convertRes2Blob } from '@/utils/exportFile'

export const baseModel = createModel(function() {
    const settingTypeList = ModoulTypeList
    /**
     * 列表
     */
        //列表数据源
    const [dataSource, setDataSource] = useState<IDetail[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<ISearchFields>({})
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IDetail>({})
    //编辑详情form
    const [detailEditForm, setDetailEditForm] = useState<IDetail>({})
    //详情form
    const [detailForm, setDetailForm] = useState<IDetail>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<IDetail[]>([])
    const [SelectedId, setSelectedId] = useState('')

    //新增，编辑状态判断
    const [mode, setMode] = useState<'add' | 'edit' | 'detail'>('add')
    //打开页面
    const [addVisible, setAddVisible] = useState(false)
    const [editVisible, setEditVisible] = useState<any>({
        visible: false,
        value: {}
    })
    const [detailVisible, setDetailVisible] = useState<any>({
        visible: false,
        value: {}
    })

    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    //新增详情form
    const [totalNum, setTotalNum] = useState<any>({})
    const {
        user: { shopCode, createUser, userType },
        fetchVehicleList
    } = useGlobalModel(({ user }) => [user])
    const [loading, setLoading] = useState<boolean>(false)
    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])

    const [meetingTypeList, setMeetingTypeList] = useState<string[]>(['培训', '会议'])
    const [meetingsStatusList, setMeetingsStatusList] = useState<string[]>(['未发布', '已发布', '已完成', '已撤回'])

    const [driverList, setDriverList] = useState<any>([])
    const getDriverList = async () => {
        const params = {
            pageSize: -1,
            pageNum: 1,
            createUserId: shopCode,
            fleet: userType === '管理员' ? createUser : undefined
        }
        let { retData } = await Service.driverList(params)
        let list =
            retData.records.map((item) => ({
                label: item.driverName,
                value: item.id,
                fleet: item.fleet,
                type: item.type,
                isChecked: false
            })) || []
        setDriverList(list)
    }

    //列表查询
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: ISearchFields = searchParam) => {
        setLoading(true)

        const searchParams = {
            ...searchValue,
            createUser: userType === '管理员' || userType === '超级管理员' ? createUser : undefined,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM
        }
        let { retData } = await Service.page(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)
        setLoading(false)
        fetchVehicleList()
    }
    //设置搜索value
    const updateSearchParam = (updateParam: ISearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {}).then(() => {})
    }

    const onDelete = (record: IDetail) => {
        globalPrompt('modal', {
            title: '提示',
            type: 'warning',
            text: '您正在删除是否确认删除？',
            okText: '确认',
            onOk: async () => {
                let list = record.map((item:any) => {
                    return { id: item.id }
                })
                let insertRet = await Service.onDelete(list)
                if (insertRet.success) {
                    message.success('删除成功!')
                } else {
                    message.success('删除失败!' + insertRet.retMsg)
                }
                await loadData()
            },
            cancelText: '取消',
            onCancel: () => {
                return
            }
        })
    }
    const handlePublish = async (record: IDetail) => {
        let status = 1
        meetingsStatusList.forEach((item, index) => {
            if (item === '已发布') {
                status = index
            }
        })
        await Service.publish({ id: record.id, status })
        message.success('发布成功!')
        await loadData()
    }
    const handleCancel = async (record: IDetail) => {
        let status = 1
        meetingsStatusList.forEach((item, index) => {
            if (item === '已撤回') {
                status = index
            }
        })
        globalPrompt('modal', {
            title: '提示',
            type: 'warning',
            text: '您正在撤回是否确认撤回？',
            okText: '确认',
            onOk: async () => {
                await Service.publish({ id: record.id, status })
                message.success('撤回成功!')
                await loadData()
            },
            cancelText: '取消',
            onCancel: () => {
                return
            }
        })
    }
    const handleExport = (ids: string[]) => {
        ids.forEach(async (item: string) => {
            let response = await Service.exportPDF(item)
            convertRes2Blob(response);
        })
    }

    const setItemColor = (status: number) => {
        const name = meetingsStatusList[status]

        switch (name) {
            case '未发布':
                return 'yellow-text'
            case '已发布':
                return 'blue-text'
            case '已完成':
                return 'green-text'
            case '已撤回':
                return 'red-text'
            default:
                return ''
        }
    }

    const initForm = () => {
        let form = {
            id: undefined,
            startTime: '',
            location: '',
            meetingsUser: '',
            meetingsUserList: [],
            title: '',
            presenter: '',
            createUser: '',
            content: '',
            qrcodePath: '',
            qrcodeImg: '',
            onlineMeetingDetailsList: [],
            meetingType: '',
            meetingMode: ''
        }
        if (mode === 'add') {
            setDetailEditForm(form)
        }
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        detailVisible,
        addVisible,
        editVisible,
        detailEditForm,
        detailAddForm,
        detailForm,
        mode,
        SelectedId,
        settingTypeList,
        totalNum,
        loading,
        initPgCfg,
        meetingTypeList,
        meetingsStatusList,
        driverList,
        /***method***/
        setEditVisible,
        setAddVisible,
        setLoading,
        setTotalNum,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        setDetailVisible,
        setDetailEditForm,
        setDetailAddForm,
        setDetailForm,
        setMode,
        setSelectedId,
        onDelete,
        setMeetingTypeList,
        setMeetingsStatusList,
        setDriverList,
        handlePublish,
        handleCancel,
        handleExport,
        setItemColor,
        initForm,
        getDriverList
    }
})
